/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOfficesQuery } from '../../models/get-offices-query';
import { OfficeListApiResponse } from '../../models/office-list-api-response';

export interface GetOfficesAsync$Plain$Params {
  query?: GetOfficesQuery;
}

export function getOfficesAsync$Plain(http: HttpClient, rootUrl: string, params?: GetOfficesAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OfficeListApiResponse>> {
  const rb = new RequestBuilder(rootUrl, getOfficesAsync$Plain.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfficeListApiResponse>;
    })
  );
}

getOfficesAsync$Plain.PATH = '/api/financial-advisor/offices';
